export { AuthHttpService } from './auth-http.service';
export { AuthHttpConfig } from './auth-http-config';
export { AuthorizationModule } from './authorization.module';



// WEBPACK FOOTER //
// /dist/src/app/security/authorization/index.ts